import { Injectable } from '@angular/core';
import { GiftCardsAppConstant } from '@src/ib-gift-cards-constants';
import { PaymentComponentConfig } from '@core/models/ib-gift-cards-payment-model';

@Injectable({providedIn: 'root'})
export class IbGiftCardsPaymentsService {
    private paymentWebComponent = null;
    private readonly INDEX_URL = `${GiftCardsAppConstant.DEFAULT_ENDPOINTS.PAYMENT_COMPONENT_URI}index.esm.js`;
    private readonly COMPONENT_ESM = `${GiftCardsAppConstant.DEFAULT_ENDPOINTS.PAYMENT_COMPONENT_URI}payment-component.esm.js`;

    private importWebComponent = async () => {
        const [PaymentComponentModule] = await Promise.all(
            [
                import(/* webpackIgnore: true*/ this.INDEX_URL),
                import(/* webpackIgnore: true*/ this.COMPONENT_ESM)
            ]
        );
        const {PaymentWebComponent} = PaymentComponentModule;
        this.paymentWebComponent = new PaymentWebComponent();
        return this.paymentWebComponent;
    };

    getNewPaymentComponent = async (componentConfig: PaymentComponentConfig) => {
        if (this.paymentWebComponent === null) {
            await this.importWebComponent();
        }
        await this.paymentWebComponent?.init(componentConfig);
        return this.paymentWebComponent;
    };
}
